import React from "react";
import "./SearchBar.scss";

/**
 *
 * @param {Object} props
 * @param {string} [props.placeholder]
 * @param {string} [props.value]
 * @param {(value: string) => void} [props.onChange]
 * @param {(value: string) => void} [props.onSubmit]
 * @param {"grid"|"list"} [props.view]
 * @param {(view: "grid"|"list") => void} [props.onViewChange]
 * @param {boolean} [props.showViewToggle]
 */
const SearchBar = ({
  placeholder = "Search collection",
  value = "",
  onChange,
  onSubmit,
  view = "list",
  onViewChange,
  showViewToggle = true,
}) => {
  const handleSubmit = (event) => {
    event.preventDefault();
    if (onSubmit) onSubmit(value);
  };

  return (
    <form className="SearchBar" onSubmit={handleSubmit}>
      <div className="SearchBar-field">
        <svg
          className="SearchBar-icon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <circle cx="7" cy="7" r="5.5" stroke="currentColor" />
          <line x1="11.2" y1="11.2" x2="15" y2="15" stroke="currentColor" />
        </svg>
        <input
          type="text"
          className="SearchBar-input"
          placeholder={placeholder}
          value={value}
          onChange={(event) => onChange && onChange(event.target.value)}
        />
      </div>

      {showViewToggle && (
        <div className="SearchBar-viewToggle">
          <button
            type="button"
            aria-label="List view"
            className={`SearchBar-viewButton ${
              view === "list" ? "is-active" : ""
            }`}
            onClick={() => onViewChange && onViewChange("list")}
          >
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <rect x="0" y="1" width="14" height="2" fill="currentColor" />
              <rect x="0" y="6" width="14" height="2" fill="currentColor" />
              <rect x="0" y="11" width="14" height="2" fill="currentColor" />
            </svg>
          </button>
        </div>
      )}
    </form>
  );
};

export default SearchBar;
